"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnauthorizedHttpError = void 0;
const http_status_codes_1 = __importDefault(require("http-status-codes"));
const AuthHttpError_1 = require("../../Error/Http/AuthHttpError");
class UnauthorizedHttpError extends AuthHttpError_1.AuthHttpError {
    constructor(message, key) {
        super(http_status_codes_1.default.UNAUTHORIZED, message, key);
    }
}
exports.UnauthorizedHttpError = UnauthorizedHttpError;
UnauthorizedHttpError.EXPIRED_JWT_ERROR = 'EXPIRED_JWT';
//# sourceMappingURL=UnauthorizedHttpError.js.map